import React from 'react';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0B1F3C] text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/phw3jo81_IMG_2623.jpeg" 
                alt="Domus & Co" 
                className="h-16 w-auto object-contain"
              />
              <div>
                <h2 className="text-2xl font-bold text-white">DOMUS & CO</h2>
                <p className="text-[#c9a961] text-sm">L'expert de la rénovation</p>
              </div>
            </div>
            <p className="text-white/80 mb-6 leading-relaxed">
              Votre partenaire de confiance pour tous vos travaux de rénovation intérieure en Île-de-France.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/domus_co_75017"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-[#c9a961] rounded-lg flex items-center justify-center transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="mailto:concept.domus.co@gmail.com"
                className="w-10 h-10 bg-white/10 hover:bg-[#c9a961] rounded-lg flex items-center justify-center transition-colors duration-300"
                aria-label="Email"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('accueil')}
                  className="text-white/80 hover:text-[#c9a961] transition-colors duration-300"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/80 hover:text-[#c9a961] transition-colors duration-300"
                >
                  Nos Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('realisations')}
                  className="text-white/80 hover:text-[#c9a961] transition-colors duration-300"
                >
                  Réalisations
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/80 hover:text-[#c9a961] transition-colors duration-300"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6">Nos Services</h3>
            <ul className="space-y-3">
              <li className="text-white/80">Rénovation Complète</li>
              <li className="text-white/80">Couverture et Charpente</li>
              <li className="text-white/80">Plâtrerie</li>
              <li className="text-white/80">Démolition / Déblai</li>
              <li className="text-white/80">Plomberie & Sanitaires</li>
              <li className="text-white/80">Électricité</li>
              <li className="text-white/80">Peinture & Décoration</li>
              <li className="text-white/80">Sols & Revêtements</li>
              <li className="text-white/80">Menuiserie Intérieure</li>
              <li className="text-white/80">Menuiserie Extérieure</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Phone className="text-[#c9a961] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="text-white/60 text-sm mb-1">Téléphone</p>
                  <a href="tel:0666770127" className="text-white hover:text-[#c9a961] transition-colors">
                    06 66 77 01 27
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="text-[#c9a961] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="text-white/60 text-sm mb-1">Email</p>
                  <a href="mailto:concept.domus.co@gmail.com" className="text-white hover:text-[#c9a961] transition-colors">
                    concept.domus.co@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="text-[#c9a961] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="text-white/60 text-sm mb-1">Zone</p>
                  <p className="text-white">Toute l'Île-de-France</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © {currentYear} Domus & Co. Tous droits réservés.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-white/60 hover:text-[#c9a961] transition-colors">
                Mentions légales
              </a>
              <a href="#" className="text-white/60 hover:text-[#c9a961] transition-colors">
                Politique de confidentialité
              </a>
              <a href="#" className="text-white/60 hover:text-[#c9a961] transition-colors">
                CGV
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
